import { ConfigurationType } from "../../shared/enums/ConfigurationType";
import { FormPage } from "../../shared/classes/form-page";
import { BaseControl } from "../../shared/classes/form-base-controls";

export interface IPlaceholder {
    placeholder?: string
}

export interface IFilter{
    filter?: boolean
}

export interface ISelectOption {
    value: string,
    text: string,
    [key: string]: string | undefined;
}

export interface IDependencyMap {
    control: string;
    mappedField: string;
    filterChangedSubId?: number
    nameChangedSubId?: number
}

export interface IControlStyle {
    startOnNewLine?: boolean
    width?: string,
    minWidth?: string,
    maxWidth?: string,
}

export interface IShowHorizontal {
    showHorizontal: boolean
}

export interface IMultiSelect {
    multiSelect: boolean
}

export interface IConfigurationSection {
    show: boolean
    type: ConfigurationType
    page?: FormPage
    control?: BaseControl<any>
    selectedElement?: HTMLElement
}

export enum Condition {
    Empty = 'empty',
    NotEmpty = 'notEmpty',
    GreaterThan = 'greaterThan',
    LessThan = 'lessThan',
    Equals = 'equals',
    DoesNotEqual = 'doesNotEqual',
    GreaterThanOrEqualsYears = 'GreaterThanOrEqualsYears',
    LessThanOrEqualsYears = 'LessThanOrEqualsYears',
}

export interface ICondition {
    label?: string;
    value: Condition;
}


export type Operator = 'and' | 'or';
export interface IToken {
    controlName: string
    condition: Condition
    value?: string
    operator: Operator
    valueChangedsubId?: number
    nameChangedSubId?: number
}

export interface IFontSize{
    fontSize: string
}

export interface IRows{
    rows: number
}

export interface IMinMax{
    min: number | undefined;
    max: number | undefined;
}

export interface IDataSourceConfig {
    columnName?: string,
    columnValue?: string
}

export interface ISourceDatasetDinamico extends IDataSourceConfig {
    tablaConsulta?: number,
}

export interface ITooltip{
    tooltip?: string
}

export interface IReadonly{
  readonly: boolean
}

//cualquier fuente que no sea interno viene de la base de datos,
//Esta debe hacer alguna peticion al servidor para obtener y configurar los datos. Pero los datos cargados no se guardan en el formulario
export enum IDataSource {
    Interno = 'interno',
    DatasetDinamico = 'dataset_dinamico',
}
